import type { GridColumnState } from '@/components/grid/types'

/**
 * Registered on the backend as a dynamic schema — see
 * `.claude/plans/dynamic-schema-table-saved-views.md`. The FE never creates
 * it: the schema exists, and a client that POSTs one on the off chance is how
 * staging ended up with two copies of the slideshow config schema.
 */
export const SCHEMA_NAME_TABLE_SAVED_VIEWS = 'table-saved-views'

export interface SavedView {
  name: string
  /**
   * The grid's own column state, in display order. A view is a layout, not
   * just a set of checkboxes: it carries which columns show, how wide they
   * are and where they sit, so switching views moves the columns rather than
   * only hiding them.
   */
  columns: GridColumnState[]
}

/**
 * Every view a user has for one grid, plus which of them is active, in a
 * single `json` field. One record per (userId, tableKey) rather than one per
 * view: rename, delete, reorder and activate are then a single write, where a
 * record per view would need a multi-record pass on every activation that
 * races between browser tabs for no benefit.
 */
export interface TableSavedViewsBlob {
  activeViewName: string | null
  items: SavedView[]
}

export interface TableSavedViewsData {
  userId: number
  tableKey: string
  views: TableSavedViewsBlob
}

/** A stored record: the dynamic-data row id, and the blob it holds. */
export interface TableSavedViewsRecord {
  id: string
  views: TableSavedViewsBlob
}

export const EMPTY_SAVED_VIEWS: TableSavedViewsBlob = {
  activeViewName: null,
  items: [],
}
